// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Text/Text.less
// module id = 241
// module chunks = 2